import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tag, TagGroup } from 'breeze-intelligence-kit';
import { useEffect, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PropertyTags = ({
  value,
  maxTags
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [tags, setTags] = useState(value);
  const handleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  useEffect(() => {
    if (isExpanded) {
      setTags(value);
    } else {
      setTags(value.slice(0, maxTags));
    }
  }, [isExpanded, value, maxTags]);
  return /*#__PURE__*/_jsxs(TagGroup, {
    flexWrap: "wrap",
    children: [tags.map((tag, index) => /*#__PURE__*/_jsx(Tag, {
      children: tag
    }, index)), maxTags && value.length > maxTags && /*#__PURE__*/_jsx(Tag, {
      onClick: () => handleExpand(),
      variant: "subtle",
      children: isExpanded ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "enrichmentProperties.table.tagCollapse"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "enrichmentProperties.table.tagExpand",
        options: {
          count: value.length - maxTags
        }
      })
    })]
  });
};